import React from "react";
import styles from "./styles.css";
import BG from "./images/bg.png";
import ArrowIcon from "../../shared/arrow";
import FIRST from "./images/first.png";
import SECOND from "./images/second.png";
import THIRD from "./images/third.png";
import Button from "../../shared/button";
import CREDIT from "./images/credit.svg";
import PropTypes from "prop-types";
import { appUrl } from "../../../constants/url-constants";

const FinancingZeroDeposit = ({
    handlePreApproval
}) => {
    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.headSection"}>
                <h2>Car loans at <span>ZERO deposits</span></h2>
                <p><a target="_blank" href={`${appUrl()}/cars24-finance`}>See how our finance works <ArrowIcon /></a></p>
            </div>
            <img src={BG} />
            <div styleName={"styles.textSection"}>
                <p><img src={FIRST} />See lenders you are eligible for</p>
                <p><img src={SECOND} />Know your borrowing capacity</p>
                <p><img src={THIRD} />See your potential interest rates </p>
            </div>
            <div styleName={"styles.buttonSection"}>
                <Button text="GET PRE-APPROVAL" onClick={handlePreApproval}/>
                <p><img src={CREDIT} />No impact on credit score</p>
            </div>
        </div>
    );
};

FinancingZeroDeposit.propTypes = {
    handlePreApproval: PropTypes.func
};

export default FinancingZeroDeposit;
